import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { buildUrlWithParams } from 'ctm-util-functions';
import { quoteIdSelector, resultsConfigSelector, tokensSelector } from 'ctm-selectors';

const withHandoverUrl = (Component) => {
    class WithState extends React.PureComponent {

        render() {
            const { journeyId, quoteId, accessToken, refreshToken, paymentFrequency, productId, currentIndex, ...rest } = this.props;

            const urlParams = {
                load_journey: 'true',
                journey_id: journeyId,
                quote_id: quoteId,
                access_token: accessToken,
                refresh_token: refreshToken,
                product_id: productId,
                product_position: currentIndex,
                payment_frequency: paymentFrequency
            };
            const href = '/car-insurance/journey/handover';
            const handoverUrl = buildUrlWithParams(href, urlParams);

            return <Component { ...rest } handoverUrl={handoverUrl} productId={productId} currentIndex={currentIndex} />;
        }

    }

    WithState.propTypes = {
        journeyId: PropTypes.number,
        quoteId: PropTypes.number,
        accessToken: PropTypes.string,
        refreshToken: PropTypes.string,
        paymentFrequency: PropTypes.string,
        // belows get from external(parent component)
        productId: PropTypes.string,
        currentIndex: PropTypes.number
    };

    return connect(mapStateToProps)(WithState);
};

/**
 * @see packages/ctm-components/components/insurer_handover/insurer_handover_button.js
 * Get journey and quote info from state to form the url query strings
 * @param {Immutable.Map} state - Redux store state
 * @returns {Object} - props that needed for build url query strings
 */
const mapStateToProps = (state) => {
    return {
        journeyId: state.getIn(['user', 'journey', 'transaction', 'journeyId']),
        quoteId: quoteIdSelector(state),
        accessToken: tokensSelector(state).get('access_token'),
        refreshToken: tokensSelector(state).get('refresh_token'),
        paymentFrequency: resultsConfigSelector(state).getIn(['filters', 'frequency'])
    };
};

export { withHandoverUrl };
